const StateCardView = ({ children, primary }) => {
  return (
    <div className={`card ${primary ? "bg-sky-50 border border-sky-300" : ""}`}>
      {children}
    </div>
  );
};

export default StateCardView;
